// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ForumCommentAdd__blockedNotice":"pq_a big_sn big_sv big_sw big_kx big_ky big_ke undefined big_vt"};